/**
 * SessionManager Component
 *
 * Invisible component that manages session lifecycle:
 * - Validates stored tokens on app load
 * - Sets up cross-tab session synchronization
 * - Cleans up listeners on unmount
 *
 * Must be rendered inside the component tree (inside BrowserRouter)
 * but renders no visible UI.
 */

import { useEffect, useRef } from 'react';
import { initSessionSync, validateSession } from '../lib/sessionSync';

export const SessionManager: React.FC = () => {
  const initialized = useRef(false);

  useEffect(() => {
    // Prevent double-initialization in React StrictMode
    if (initialized.current) return;
    initialized.current = true;

    // Validate the session (check token expiry, proactive refresh)
    validateSession();

    // Set up cross-tab session synchronization
    const cleanup = initSessionSync();

    return () => {
      cleanup();
    };
  }, []);

  // Render nothing — this is a side-effect-only component
  return null;
};

SessionManager.displayName = 'SessionManager';